<template>
  <header class="app-header">
    <img
      class="header-logo mw-100 mh-100"
      src="../../public/msm_loop_logo_40px.png"
      @click="routerPush('/'); showMenu = false;"
    />
    <div class="header-navigation px-4">
      <span
        :class="'header-link ' + (currentRoute === '/management' ? 'header-link-active' : '')"
        v-if="hasPermission('Management')"
        @click="routerPush('/management'); showMenu = false;"
      >
        <span class="header-text-long">Geschäftsführung</span>
        <span class="header-text-short">GF</span>
      </span>
      <span
        :class="'header-link ' + (currentRoute === '/sales' ? 'header-link-active' : '')"
        v-if="hasPermission('Sales')"
        @click="routerPush('/sales'); showMenu = false;"
      >Vertrieb
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/projectManagement' ? 'header-link-active' : '')"
        v-if="hasPermission('ProjectManagement')"
        @click="routerPush('/projectManagement'); showMenu = false;"
      >
        <span class="header-text-long">Projektmanagement</span>
        <span class="header-text-short">PM</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/qualityAssurance' ? 'header-link-active' : '')"
        v-if="hasPermission('QualityAssurance')"
        @click="routerPush('/qualityAssurance'); showMenu = false;"
      >
        <span class="header-text-long">Qualitätssicherung</span>
        <span class="header-text-short">QSS</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/field' ? 'header-link-active' : '')"
        v-if="hasPermission('Field')"
        @click="routerPush('/field'); showMenu = false;"
      >Feld
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/shopperCosts' ? 'header-link-active' : '')"
        v-if="hasPermission('ShopperCosts')"
        @click="routerPush('/shopperCosts'); showMenu = false;"
      >
        <span class="header-text-long">Testkundenkosten</span>
        <span class="header-text-short">TKK</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/agency-costs' ? 'header-link-active' : '')"
        v-if="hasPermission('AgencyCostsAndInvoicing') || hasPermission('AllocationAsProjectManager')"
        @click="routerPush('/agency-costs'); showMenu = false;"
      >
        <span class="header-text-long">Agenturkosten</span>
        <span class="header-text-short">AK</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/invoicing' ? 'header-link-active' : '')"
        v-if="hasPermission('AgencyCostsAndInvoicing') || hasPermission('AllocationAsProjectManager')"
        @click="routerPush('/invoicing'); showMenu = false;"
      >
        <span class="header-text-long">Rechnungsstellung</span>
        <span class="header-text-short">RS</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/orderManagement' ? 'header-link-active' : '')"
        v-if="hasPermission('OrderManagement')"
        @click="routerPush('/orderManagement'); showMenu = false;"
      >
        <span class="header-text-long">Auftragsverwaltung</span>
        <span class="header-text-short">Auftrags-<br>verwaltung</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/invoiceManagement' ? 'header-link-active' : '')"
        v-if="hasPermission('InvoiceManagement')"
        @click="routerPush('/invoiceManagement'); showMenu = false;"
      >
        <span class="header-text-long">Rechnungsverwaltung</span>
        <span class="header-text-short">Rechnungs-<br>verwaltung</span>
      </span>

      <!-- <span
      :class="'header-link ' + (currentRoute === '/costCenterManagement' ? 'header-link-active' : '')"
        v-if="hasPermission('CostCenterManagement')"
        @click="routerPush('/costCenterManagement')"
      >
        <span class="header-text-long">Kostenstellenverwaltung</span>
        <span class="header-text-short">Kostenstellen-<br>verwaltung</span>
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/archive' ? 'header-link-active' : '')"
        v-if="hasPermission('Archive')"
        @click="routerPush('/archive')"
      >Archiv
      </span>
      <span
      :class="'header-link ' + (currentRoute === '/userManagement' ? 'header-link-active' : '')"
        v-if="hasPermission('UserManagement')"
        @click="routerPush('/userManagement')"
      >
        <span class="header-text-long">Benutzerverwaltung</span>
        <span class="header-text-short">BV</span>
      </span>
      <div class="header-link" @click="logout()">Logout</div> -->

      <FontAwesomeIcon 
        :class="'mx-2 clickable' + (showMenu ? ' header-link-active' : '')"
        icon="fa-solid fa-bars"
        style="cursor: pointer; margin: auto; right: 0px"
        @click="showMenu = !showMenu"
      />
      <div class="header-menu" v-if="showMenu">
        <span
        :class="'menu-item header-link ' + (currentRoute === '/costCenterManagement' ? 'header-link-active' : '')"
          v-if="hasPermission('CostCenterManagement')"
          @click="routerPush('/costCenterManagement')"
        >Kostenstellenverwaltung</span>
        <span
          :class="'menu-item header-link ' + (currentRoute === '/archive' ? 'header-link-active' : '')"
            v-if="hasPermission('Archive')"
            @click="routerPush('/archive')"
        >Archiv</span>
        <span
          :class="'menu-item header-link ' + (currentRoute === '/userManagement' ? 'header-link-active' : '')"
            v-if="hasPermission('UserManagement')"
            @click="routerPush('/userManagement')"
          >Benutzerverwaltung</span>
        <div class="menu-item header-link" @click="logout()">Logout</div>
      </div>
    </div>
  </header>
</template>

<script>
import AuthenticationService from "../services/AuthenticationService";

export default {
  data() {
    return { 
      showMenu: false
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path
    }
  },
  methods: {
    hasPermission(permission) {
      return AuthenticationService.hasPermission(permission);
    },
    logout() {
      AuthenticationService.logout();
    },
    routerPush(path) {
      if (this.currentRoute != path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped>
.app-header {
  position: sticky;
  z-index: 100;
  top: 0%;
  width: 100%;
  height: 40px;
  background: #52688d;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.5);
}
.header-logo {
  background: white;
  cursor: pointer;
  padding: 0.25rem 1rem;
}
.header-navigation {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header-link {
  text-align: center;
  margin: auto;
  line-height: 15px;
}
.header-link:hover {
  cursor: pointer;
  color: white;
}
.header-link-active {
  color: white;
}
.header-text-long {
  display: block;
}
.header-text-short {
  display: none;
}
.header-menu {
  position: fixed;
  background: #52688d;
  display: flex;
  flex-direction: column;
  right: 0px;
  top: 40px;
  padding: 10px;
  border: 1px solid lightgray;
}
.menu-item {
  margin: 5px 0px;
}
@media screen and (max-width: 1400px) {
  .header-text-long {
    display: none;
  }
  .header-text-short {
    display: block;
  }
}
</style>